import React from 'react';
import DetailPanelLeft from './detail_panel_left';
import DetailPanelRight from './detail_panel_right';

import '../../www/assets/css/details_panel.css';

class DetailPanel extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			open: props.isPanelOpen || false,
			type: null
		};

		this.close = this.close.bind(this);
		this.toggle = this.toggle.bind(this);
		this.toggleOverlay = this.toggleOverlay.bind(this);
	}

	static getDerivedStateFromProps(nextProps, state) {
		const { type, isMobile } = nextProps;
		const props = {
			type
		};

		// Close panel if switch type or is on mobile
		if (type !== state.type || isMobile) {
			props.isPanelOpen = false;
		}

		const newState = Object.entries(props).reduce((obj, [key, value]) => {
			if (key in state && state[key] !== props[key]) {
				obj[key] = value;
			}
			return obj;
		}, {});

		return newState;
	}

	close() {
		this.setState({ open: false });
	}

	toggleOverlay() {
		const { detailOverlayRef } = this.props;
		if (detailOverlayRef.current) {
			detailOverlayRef.current.toggle();
		}
	}

	toggle() {
		const { isPanelOpen, setPanelOpenState } = this.props;

		this.setState({ open: isPanelOpen });
		setPanelOpenState(!isPanelOpen);
	}

	render() {
		if (!['vitalsign', 'spacecraft', 'event', 'poi', 'gmap'].includes(this.props.type)) {
			return null;
		}
		const {
			type, isMobile, hideLeftContent, hideTitle, hideButton,
			vitalsign, altid, altView, missionName, event, poi, gmap,
			hideRightContent, get, handleSelection, pioneer, isPanelOpen,spacecraft
		} = this.props;
		const leftProps = {
			type,
			isMobile,
			hideTitle,
			hideButton,
			vitalsign,
			altid,
			altView,
			missionName,
			event,
      poi,
	  gmap,
			get,
			pioneer
		};

		const rightProps = {
			type,
			altid,
			spacecraft,
			handleSelection
		};

		return (
			<div id='detail-panel' className={isPanelOpen ? 'w-100 active scrollable' : 'disabled'}>
				<div className='container mx-0'>
					<div className='detail-content-container'>
						{
							!hideLeftContent
							&& (
								<DetailPanelLeft
									{...leftProps}
									toggle={this.toggle}
									toggleOverlay={this.toggleOverlay}
									open={isPanelOpen}
								/>
							)
						}
						{
							!hideRightContent
							&& (
								<DetailPanelRight
									{...rightProps}
								/>
							)
						}
					</div>
				</div>
			</div>
		);
	}
}

export default DetailPanel;
